module.exports = __webpack_public_path__ + "static/media/efsbi.caed92e5.png";